export const styles = {
  tableCellContent: {
    borderBottom: '1px solid rgba(226, 226, 252, 1)',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    color: '#273754',
  },
  deleteIcon: {
    marginLeft: '20px',
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3px 15px;',
    borderRadius: '8px',
    backgroundColor: '#F9F9FF',
    minWidth: '100px',
  },
}
